module.exports = __webpack_public_path__ + "img/img-3.4b77d5e2.png";